import { Children, ReactNode, isValidElement } from 'react';

export const getTextFromChildren = (children: ReactNode): string => {
  return Children.toArray(children)
    .reduce((text: string, child): string => {
      if (typeof child === 'string' || typeof child === 'number') {
        return text + String(child);
      }
      if (isValidElement(child) && child.props.children) {
        return text + getTextFromChildren(child.props.children);
      }
      return text;
    }, '')
    .toString();
};
